export default __webpack_public_path__ + "static/media/newsEve2.6dfece30.jpg";